export default {"src":"/_next/static/media/cs-logo-blue.0fa894c5.svg","height":39,"width":198,"blurWidth":0,"blurHeight":0};